import { Component, Input, OnInit, Output, EventEmitter, HostListener, ViewChild, ElementRef, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { ASSETS_CONSTANTS } from 'src/app/core/constants/Assets-constants';
import { FLAGS_NAME, GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { Payment, Transaction } from 'src/app/models';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { environment } from 'src/environments/environment';
import QRCode from 'qrcode';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-yape-peru',
  templateUrl: './yape-peru.component.html',
  styleUrls: ['./yape-peru.component.scss'],
})
export class YapePeruComponent implements OnInit, AfterViewChecked {
  @Input() info: Payment;
  @Output() YAPE = new EventEmitter();
  @ViewChild('canvas', { static: false }) canvas!: ElementRef;

  transaction: Transaction;
  loading: boolean;
  template: string;
  yape_logo: string = environment.logo_yape;
  yape_video_payvalida_yt: string = 'https://r.payvalida.com/yape-onboarding';
  // UNDONE: Remove this conditional when Yape updates goes to production
  yape_app_url: string = environment.production ? 'https://r.payvalida.com/checkout/yape-deeplink' : 'https://r.payvalidadev.com/checkout/yape-deeplink';
  yape_app_updated_url: string = '';
  isMobile: boolean = false;
  yapeAppQr: string = ASSETS_CONSTANTS.YAPE_APP_QR;
  yapeNewQrStepsFF: boolean = false;
  reference: string = '';
  qrGenerated = false;

  constructor(
    private readonly tokenServiceService: TokenServiceService,
    private featureFlagService: PayvalidaFeatureFlagService,
    private alertService: AlertService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.YAPE_NEW_QR_STEPS_FF, FLAGS_NAME.YAPE_NEW_QR_STEPS_FF).subscribe((response: boolean) => {
      this.yapeNewQrStepsFF = response;

      if (this.yapeNewQrStepsFF) {
        this.yape_app_url = `https://www.yape.com.pe/app/services-pay/pickService?logo=https://staceu2yapefrntp10.blob.core.windows.net/$web/bill-payment/companies/payvalida/payvalida.png&companyId=B1122D95-8108-4071-997D-FEE16F49CF92&name=Payvalida&serviceId=10B857B9-B4CE-4085-9E71-5DDF57F700D4&consumerCode=${this.reference}&origin=deeplink-externo&origin_detail=tercero-web&utm_source=tercero-web&utm_medium=referral&utm_campaign=pago-de-servicios_pago-de-servicios_ext_alcance_payvalida`;
      }
    });
  }

  ngAfterViewChecked(): void {
    if (this.yapeNewQrStepsFF && !this.qrGenerated && this.canvas) this.generateQR();
  }

  ngOnInit(): void {
    this.setDeviceType(window.innerWidth);
    this.template = this.info.template;
    this.loading = false;
    this.transaction = this.tokenServiceService.getAndDecodeToken();
    this.reference = this.transaction.ORDER_REFERENCE;
  }

  changeMethod() {
    this.YAPE.emit();
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    const width = (event.target as Window).innerWidth;
    this.setDeviceType(width);

    if (this.isMobile) return;

    this.changeDetector.detectChanges();

    if (this.yapeNewQrStepsFF && this.canvas) this.generateQR();
  }

  setDeviceType(width: number) {
    this.isMobile = width < 768;
  }

  /**
   * @description Function to generate the YAPE QR code
  */
  generateQR() {
    this.qrGenerated = true;

    try {
      QRCode.toCanvas(this.canvas.nativeElement, this.yape_app_url, { errorCorrectionLevel: 'H' }, (error: any) => {
        if (error) this.alertService.showAlert(GENERAL_CONSTANTS.RESPONSE_ERROR_YAPE.ERROR_CREATING_QR_CODE)
      });
    } catch (_) {
      this.alertService.showAlert(GENERAL_CONSTANTS.RESPONSE_ERROR_YAPE.ERROR_CREATING_QR_CODE);
    }
  }
}
